import { Helmet } from "./Helmet";

export function DocumentTitle({ children }: { children: string }) {
  return (
    <Helmet>
      <title>{children}</title>
    </Helmet>
  );
}
